<template>
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="19.5"
      cy="19.5"
      r="19.5"
      fill="var(--systemSuccess)"
    />
    <path
      d="M31.1348 10.5621C29.7608 9.64356 28.3108 10.2129 27.3391 11.3516C25.5779 13.4089 23.2474 14.912 21.2205 16.6807C19.4593 18.2142 17.8196 19.9071 16.2178 21.6303C14.9576 20.2335 13.6899 18.8443 12.3917 17.4778C9.98529 14.9423 5.93151 18.5027 8.32279 21.0837C10.2965 23.2169 12.202 25.4032 14.115 27.5895C15.0411 28.6447 16.9769 28.9636 18.0169 27.8552C20.3399 25.3804 22.7084 22.8601 25.2895 20.6586C27.6124 18.6773 30.1176 16.9313 31.9167 14.4033C32.7821 13.1963 32.3267 11.3592 31.1348 10.5621Z"
      fill="white"
    />
  </svg>
</template>